import React, { useEffect, useState } from "react";
import image01 from "../../assets/images/Ellipse 1.png";
import image02 from "../../assets/images/i m student.png";
import { toast } from "react-toastify";
import { signUp } from "../../services/auth";
import Loader from "../loader";
import { useNavigate } from "react-router-dom";
import { STUDENT_ROLE, TEACHER_ROLE } from "../../constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "./style.css";
import { useDispatch } from "react-redux";
import { GoEyeClosed } from "react-icons/go";
import { FiEye } from "react-icons/fi";
import { Select } from "antd";
import {
  getAreasAPI,
  getCitiesAPI,
  getCountriesAPI,
  getProvenciesAPI,
} from "../../services/teacher";
import { signUpAddressSchema } from "../../helper/schemas";
import { ErrorMessage } from "../errorMessage";

const INITIAL_STATE = {
  fullName: "",
  email: "",
  userName: "",
  password: "",
  phoneNumber: "",
  confirmPassword: "",
  role: "", // Default to "teacher" role
};
const SignUp = ({ openSignUp, handleSignUpModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ ...INITIAL_STATE });

  const [loading, setLoading] = useState(false);
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [openSignInModal, setOpenSignInModal] = useState(false);
  const [isTeacher, setIsTeacher] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const initialAreasList = {
    country: [],
    province: [],
    city: [],
    area: [],
  };

  const [areasList, setAreasList] = useState({ ...initialAreasList });

  useEffect(() => {
    getcountries();
  }, []);

  useEffect(() => {
    if (formData?.countryId) {
      getprovencies(formData?.countryId);
    }
  }, [formData?.countryId]);

  useEffect(() => {
    if (formData?.provinceId) {
      getCity(formData?.provinceId);
    }
  }, [formData?.provinceId]);

  useEffect(() => {
    if (formData?.cityId) {
      getArea(formData?.cityId);
    }
  }, [formData?.cityId]);

  const getcountries = async () => {
    try {
      const { status, data: res } = await getCountriesAPI();

      if (status === 200) {
        setAreasList((pre) => ({
          ...pre,
          country: res.data,
        }));
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const getprovencies = async (id) => {
    try {
      const { status, data: res } = await getProvenciesAPI(id);

      if (status === 200) {
        setAreasList((pre) => ({
          ...pre,
          province: res.data,
        }));
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const getCity = async (id) => {
    try {
      const { status, data: res } = await getCitiesAPI(id);

      if (status === 200) {
        setAreasList((pre) => ({
          ...pre,
          city: res.data,
        }));
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const getArea = async (id) => {
    try {
      const { status, data: res } = await getAreasAPI(id);

      if (status === 200) {
        setAreasList((pre) => ({
          ...pre,
          area: res.data,
        }));
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOk = () => {
    setFormData({ ...INITIAL_STATE });
    handleSignUpModal(false);
  };

  const handleCancel = () => {
    setFormData({ ...INITIAL_STATE });
    handleSignUpModal(false);
  };

  const handleSelection = () => {
    setIsTeacher(!isTeacher);
    setFormData({ ...INITIAL_STATE });
  };

  const handleOTPModal = (status) => {
    setOpenOTPModal(status);
  };

  const handleOpenSignInModal = () => {
    setOpenSignInModal(true);
    handleSignUpModal(false);
  };
  const handleSignInModal = (status) => {
    setOpenSignInModal(status);
    // handleSignUpModal(false);
    // if (openSignUp) {
    // }
  };

  const moveToJourneyScreen = (url) => {
    navigate(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // debugger
    let tempError = {};
    if (!isTeacher) {
      try {
        const validData = await signUpAddressSchema.validate(formData, {
          abortEarly: false,
        });
        console.log(validData);
        setErrors({});
      } catch (errors) {
        let errorMessages = {};
        errors.inner.forEach((err) => {
          errorMessages[err.path] = err.message;
        });
        console.log(errorMessages);
        setErrors(errorMessages);
        tempError = errorMessages;
      }
    }

    if (Object.keys(tempError).length) return;

    try {
      if (formData?.password === formData?.confirmPassword) {
        setLoading(true);
        let payload = {
          ...formData,
          role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
        };
        const { status, data } = await signUp(payload);
        if (status === 201) {
          handleSignUpModal(false);
          setFormData({ ...INITIAL_STATE });
          // if (isTeacher) {
          //   let stringify = JSON.stringify(data?.data);
          //   localStorage.setItem(USER_SIGN_UP_DETAIL, stringify);
          //   dispatch(setSignUpUserDetail(data?.data));
          //   moveToJourneyScreen(TEACHER_JOURNEY_URL);
          // } else {
          //   handleOTPModal(true);
          // }
          handleSignInModal(true);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error("Password is not matched!!");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* otp modal */}
      {/* {openOTPModal ? (
        ) : (
          ""
          )} */}
      {/* <OTP openOTPModal={openOTPModal} handleOTPModal={handleOTPModal} /> */}

      {/* Button Code Start */}
      <div className="d-md-block text-center py-3">
        <button
          onClick={() => handleSelection()}
          className={`btn mb-3 mx-4 shadow-sm px-5 ${
            isTeacher ? "btn-primary primary_bg_color" : ""
          }`}
          type="button"
        >
          <img
            className="signUpTeacher mx-2"
            src={image01}
            alt="Icon"
            width="30px"
          />{" "}
          I'm a Teacher
        </button>
        <button
          onClick={() => handleSelection()}
          className={`btn ${
            !isTeacher ? "btn-primary primary_bg_color" : ""
          } shadow-sm mb-3 px-5`}
          type="button"
        >
          <img
            className="signUpStudent mx-2"
            src={image02}
            alt="Icon"
            width="30px"
          />{" "}
          I'm a Student
        </button>
      </div>
      {/* Button Code Ends */}

      {/* Form Code Start */}
      <div className="teacherSignUp">
        <h4 className="fw-bold text-center">
          {isTeacher ? "Welcome, Teacher" : "Welcome, Student"}
        </h4>
        <p className="signUp text-center fs_12">Enter the information.</p>
        <form onSubmit={handleSubmit} className="mx-auto col-md-7 col-sm-6">
          <div className="mb-2">
            <label htmlFor="firstName" className="form-label fs_12 fw-bold">
              First Name *
            </label>
            <input
              onChange={handleChange}
              value={formData?.fullName || ""}
              name="fullName"
              type="text"
              className="form-control"
              id="firstName"
              aria-describedby="emailHelp"
              required
            />
          </div>
          <div className="mb-2">
            <label htmlFor="email" className="form-label fs_12 fw-bold">
              Email Address *
            </label>
            <input
              onChange={handleChange}
              value={formData?.email || ""}
              name="email"
              type="email"
              className="form-control"
              id="email"
              aria-describedby="emailHelp"
              required
            />
          </div>

          {isTeacher ? (
            <div className="mb-2">
              <label htmlFor="userName" className="form-label fs_12 fw-bold">
                User Name *
              </label>
              <input
                onChange={handleChange}
                value={formData?.userName || ""}
                name="userName"
                type="text"
                className="form-control"
                id="userName"
                aria-describedby="emailHelp"
                required
              />
            </div>
          ) : (
            <div className="mb-2">
              <label htmlFor="number" className="form-label fs_12 fw-bold">
                Mobile Number *
              </label>
              <PhoneInput
                country={"pk"}
                enableSearch={true}
                value={formData?.phoneNumber || ""}
                onChange={(phone) =>
                  setFormData((prev) => ({
                    ...prev,
                    phoneNumber: phone,
                  }))
                }
                inputProps={{
                  required: true,
                }}
                // isValid={(value) => {
                //   // Extract the digits after the country dial code
                //   const digitsAfterDialCode = value.replace(/^\+\d+/, '').replace(/\D/g, '');

                //   // Check if there are 5 consecutive numbers after the dial code
                //   if (/^(\+\d{1,3}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)) {
                //     alert("phone number not correct");
                //     return true; // Return false for invalid value
                //   } else {
                //     // alert("phone number correct");

                //     return false; // Return true for valid value
                //   }
                // }}
              />
              {/* <input
                  onChange={handleChange}
                  value={formData?.phoneNumber || ""}
                  name="phoneNumber"
                  type="number"
                  className="form-control"
                  id="number"
                  aria-describedby="emailHelp"
                  required
                /> */}
            </div>
          )}

          {/* Student Address */}
          {!isTeacher && (
            <>
              <div className="mb-2">
                <label htmlFor="userName" className="form-label fs_12 fw-bold">
                  Country
                </label>
                <Select
                  showSearch
                  // placeholder="Enter your Country"
                  optionFilterProp="children"
                  onChange={(value) =>
                    setFormData({ ...formData, countryId: value })
                  }
                  // onSearch={onSearch}
                  value={formData?.countryId || null}
                  filterOption={filterOption}
                  options={areasList?.country?.map((data) => ({
                    label: data.name,
                    value: data.id,
                  }))}
                  className={`d-block selectHeight w-100 bg-transparent`}
                />

                <ErrorMessage message={errors?.countryId} />
              </div>

              <div className="mb-2">
                <label htmlFor="userName" className="form-label fs_12 fw-bold">
                  Provience
                </label>
                <Select
                  showSearch
                  // placeholder="Enter your Provience"
                  optionFilterProp="children"
                  onChange={(value) =>
                    setFormData({ ...formData, provinceId: value })
                  }
                  // onSearch={onSearch}
                  value={formData?.provinceId || null}
                  filterOption={filterOption}
                  options={areasList?.province?.map((data) => ({
                    label: data.name,
                    value: data.id,
                  }))}
                  className={`d-block selectHeight w-100 bg-transparent`}
                />

                <ErrorMessage message={errors?.countryId} />
              </div>

              <div className="mb-2">
                <label htmlFor="userName" className="form-label fs_12 fw-bold">
                  City
                </label>
                <Select
                  showSearch
                  // placeholder="Enter your City"
                  optionFilterProp="children"
                  onChange={(value) =>
                    setFormData({ ...formData, cityId: value })
                  }
                  // onSearch={onSearch}
                  value={formData?.cityId || null}
                  filterOption={filterOption}
                  options={areasList?.city?.map((data) => ({
                    label: data.name,
                    value: data.id,
                  }))}
                  className={`d-block selectHeight w-100 bg-transparent`}
                />

                <ErrorMessage message={errors?.countryId} />
              </div>

              <div className="mb-2">
                <label htmlFor="userName" className="form-label fs_12 fw-bold">
                  Area
                </label>
                <Select
                  showSearch
                  // placeholder="Enter your Area"
                  optionFilterProp="children"
                  onChange={(value) =>
                    setFormData({ ...formData, areaId: value })
                  }
                  // onSearch={onSearch}
                  value={formData?.areaId || null}
                  filterOption={filterOption}
                  options={areasList?.area?.map((data) => ({
                    label: data.name,
                    value: data.id,
                  }))}
                  className={`d-block selectHeight w-100 bg-transparent`}
                />

                <ErrorMessage message={errors?.countryId} />
              </div>

              <div className="mb-2">
                <label htmlFor="userName" className="form-label fs_12 fw-bold">
                  Present Address
                </label>
                <input
                  onChange={handleChange}
                  value={formData?.address || ""}
                  name="address"
                  type="text"
                  className="form-control"
                  id="address"
                  required
                />
              </div>
            </>
          )}

          <div className="mb-2">
            <label htmlFor="password" className="form-label fs_12 fw-bold">
              Password *
            </label>
            <div className="d-flex position-relative">
              <input
                onChange={handleChange}
                value={formData?.password || ""}
                name="password"
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="password"
                aria-describedby="emailHelp"
                required
              />
              <span className="password-toggle position-absolute">
                {showPassword ? (
                  <FiEye onClick={toggleShowPassword} />
                ) : (
                  <GoEyeClosed onClick={toggleShowPassword} />
                )}
              </span>
            </div>
          </div>
          <div className="mb-2">
            <label
              htmlFor="confirmPassword"
              className="form-label fs_12 fw-bold"
            >
              Confirm Password *
            </label>
            <div className="d-flex position-relative">
              <input
                onChange={handleChange}
                value={formData?.confirmPassword || ""}
                name="confirmPassword"
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="confirmPassword"
                aria-describedby="emailHelp"
                required
              />
              <span className="password-toggle position-absolute">
                {showPassword ? (
                  <FiEye onClick={toggleShowPassword} />
                ) : (
                  <GoEyeClosed onClick={toggleShowPassword} />
                )}
              </span>
            </div>
          </div>

          <button
            disabled={loading}
            type="submit"
            className="btn btn_contained  btn-primary col-12 p-2 my-3"
          >
            {loading ? <Loader /> : "Submit"}
          </button>
        </form>
        {/* <div className="signUpText mt-3 text-center fs_12">
            <p>
              Already have account?{" "}
              <span
                onClick={() => handleOpenSignInModal()}
                className="link-dark text-decoration-none fw-bold cursor_pointer"
              >
                Sign In
              </span>
            </p>
          </div> */}
      </div>
      {/* Form Code Ends */}
    </>
  );
};

export default SignUp;
